import { render, staticRenderFns } from "./TabConfiguration.vue?vue&type=template&id=7eff20bc&"
import script from "./TabConfiguration.vue?vue&type=script&lang=js&"
export * from "./TabConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports